import React from 'react';
import { DataTable, Button, InlineNotification } from 'carbon-components-react';
import { CheckmarkOutline24, MisuseAlt24 } from '@carbon/icons-react';
import { OverflowMenuCell } from './components';
import './DataTable.css';
import funcTranslateHelper from '../../../i18next/funcTranslateHelper';

const {
  TableContainer,
  TableToolbar,
  TableToolbarSearch,
  TableToolbarContent,
  Table,
  TableHead,
  TableHeader,
  TableExpandHeader,
  TableBody,
  TableRow,
  TableExpandRow,
  TableExpandedRow,
  TableCell
} = DataTable;

export const CarbonDataTable = props => {
  const {
    title,
    subtitle,
    handleOpen,
    onDelete,
    onEdit,
    headers,
    rows,
    renderExpandable,
    hasExpandableRows,
    notification,
    allowEdit = true,
    buttonText = 'Add item'
  } = props;

  function parseCellValue (value) {
    let type = typeof value;
    type = type === 'object' && Array.isArray(value) ? 'array' : type;
    switch (type) {
      case 'undefined':
        return '';
      case 'array':
        return value.join(', ');
      case 'boolean':
        return value ? (
          <CheckmarkOutline24 fill='#3DBB61' />
        ) : (
          <MisuseAlt24 fill='#FB4B53' />
        );
      default:
        return value.toString();
    }
  }

  return (
    <div className='dataTable'>
      <DataTable
        isSortable
        // style={{ maxHeight: 500, overflow: 'scroll' }}
        headers={headers}
        rows={rows}
        render={({
          rows,
          headers,
          getHeaderProps,
          onInputChange,
          getRowProps
        }) => (
          <TableContainer title={title} description={subtitle}>
            {notification && (
              <div className='data-table_notification'>
                <InlineNotification
                  iconDescription='Cerrar notificación'
                  kind={notification.type}
                  lowContrast
                  title={funcTranslateHelper(notification.message)}
                />
              </div>
            )}
            <TableToolbar>
              <TableToolbarContent>
                <TableToolbarSearch
                  onChange={onInputChange}
                  placeHolderText='Buscar'
                />
                {allowEdit &&
                  <Button onClick={handleOpen} size='field' kind='primary'>
                    {buttonText}
                  </Button>}
              </TableToolbarContent>
            </TableToolbar>
            <div id='table-wrapper'>
              <div id='table-scroll'>
                <Table>
                  <TableHead>
                    <TableRow>
                      {hasExpandableRows && <TableExpandHeader />}
                      {headers.map((header, i) => (
                        <TableHeader
                          key={i}
                          {...getHeaderProps({ header })}
                          className='header_cell'
                        >
                          {funcTranslateHelper(`Builder.Table.${header.header}`)}
                        </TableHeader>
                      ))}
                      {allowEdit && <TableHeader style={{ width: '5%' }} />}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {hasExpandableRows
                      ? rows.map(row => (
                        <React.Fragment key={row.id}>
                          <TableExpandRow {...getRowProps({ row })}>
                            {row.cells.map(cell => (
                              <TableCell key={cell.id}>
                                <span className='data-table_cell-value'>
                                  {parseCellValue(cell.value)}
                                </span>
                              </TableCell>
                            ))}
                            {allowEdit && (
                              <OverflowMenuCell
                                id={row.id}
                                onEdit={onEdit}
                                onDelete={onDelete}
                              />
                            )}
                          </TableExpandRow>
                          {row.isExpanded && (
                            <TableExpandedRow
                              colSpan={headers.length + 2}
                              className='child-row-expandable'
                            >
                              {renderExpandable(row.id)}
                            </TableExpandedRow>
                          )}
                        </React.Fragment>
                      ))
                      : rows.map(row => (
                        <TableRow {...getRowProps({ row })} key={row.id}>
                          {row.cells.map(cell => (
                            <TableCell key={cell.id}>
                              <span style={{ padding: '0 0.5rem' }}>
                                {parseCellValue(cell.value)}
                              </span>
                            </TableCell>
                          ))}
                          {allowEdit && (
                            <OverflowMenuCell
                              id={row.id}
                              onEdit={onEdit}
                              onDelete={onDelete}
                            />
                          )}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </div>
            </div>
          </TableContainer>
        )}
      />
    </div>
  );
};

export default CarbonDataTable;
